const DISABLE_ON_DEV = true // Set to false to enable Taboola in development

const TABOOLA_SCRIPT_SRC = '//cdn.taboola.com/libtrc/unip/1317354/tfa.js'
const TABOOLA_SCRIPT_ID = 'tb_tfa_script'
const TABOOLA_PIXEL_ID = 1317354

interface IPurchaseInfo {
  orderid: string
  currency: string
  revenue: number
}

export interface ITaboolaService {
  logPurchase: (info: IPurchaseInfo) => void
  logEvent: (eventName: string, params?: Record<string, any>) => void
}

export const initTaboolaService = () => {
  if (__DEV__ && DISABLE_ON_DEV) return

  if (typeof window === 'undefined') return

  // Prevent multiple loads
  if (document.getElementById(TABOOLA_SCRIPT_ID)) return

  // Setup global object
  window._tfa = window._tfa || []
  window._tfa.push({ notify: 'event', name: 'page_view', id: TABOOLA_PIXEL_ID })

  // Inject script
  const script = document.createElement('script')
  script.async = true
  script.src = TABOOLA_SCRIPT_SRC
  script.id = TABOOLA_SCRIPT_ID

  const firstScript: any = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(script, firstScript)
}

export const revokeTaboolaConsent = () => {
  if (__DEV__ && DISABLE_ON_DEV) return

  // Remove the script from DOM
  const existingScript = document.getElementById(TABOOLA_SCRIPT_ID)
  if (existingScript) {
    existingScript.remove()
  }
}

export const createTaboolaService = (): ITaboolaService | null => {
  if (__DEV__ && DISABLE_ON_DEV) return null

  const taboolaService: ITaboolaService = {
    logPurchase: (info?: Record<string, any>) => {
      if (!window._tfa) return

      window._tfa.push({
        notify: 'event',
        name: 'make_purchase',
        id: TABOOLA_PIXEL_ID,
        ...info
      })
    },
    logEvent: (eventName: string, params?: Record<string, any>) => {
      if (!window._tfa) return

      window._tfa.push({
        notify: 'event',
        name: eventName,
        id: TABOOLA_PIXEL_ID,
        ...params
      })
    }
  }

  return taboolaService
}
